import React from "react";

const LinkedIn = ({ ...rest }) => {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <g id="logo-linkedin">
                <path
                    id="Vector"
                    d="M12.6852 10.9725C12.9435 10.6981 13.1546 10.4216 13.4196 10.1854C14.2325 9.46005 15.1937 9.09418 16.3143 9.10268C16.9297 9.10694 17.5405 9.14948 18.1356 9.31328C19.4943 9.68555 20.2848 10.5726 20.662 11.8298C20.945 12.7722 20.9967 13.7422 20.9989 14.7144C21.0034 16.7629 20.9922 18.8136 20.9989 20.8621C20.9989 21.0535 20.9428 21.1046 20.7429 21.1025C19.629 21.094 18.5129 21.094 17.399 21.1025C17.2036 21.1025 17.161 21.0472 17.161 20.8706C17.1677 18.9199 17.1677 16.9692 17.161 15.0207C17.161 14.5314 17.1273 14.0443 16.9813 13.5678C16.7141 12.6935 16.0538 12.2468 15.0859 12.2957C13.7632 12.3616 13.076 12.9828 12.9076 14.2549C12.8671 14.5591 12.8492 14.8633 12.8492 15.1696C12.8492 17.0671 12.8492 18.9625 12.8537 20.86C12.8537 21.0493 12.8043 21.1046 12.5999 21.1025C11.477 21.094 10.3542 21.094 9.23131 21.1025C9.05165 21.1025 9 21.0578 9 20.8855C9.00449 17.1309 9.00449 13.3763 9 9.6196C9 9.43453 9.06512 9.38986 9.24927 9.39199C10.316 9.4005 11.3827 9.4005 12.4472 9.39199C12.6426 9.39199 12.6942 9.44942 12.6897 9.62598C12.6785 10.0748 12.6852 10.5237 12.6852 10.9725Z"
                    stroke="currentColor"
                    strokeWidth="1.33"
                    strokeLinejoin="round"
                />
                <path
                    id="Vector_2"
                    d="M6.99534 15.1186C6.99534 17.0217 6.993 18.9269 7 20.83C7 21.0414 6.94403 21.1047 6.71079 21.1025C5.55394 21.0916 4.39708 21.0938 3.24023 21.1025C3.05364 21.1025 3 21.0611 3 20.8801C3.00466 17.026 3.00466 13.172 3 9.31786C3 9.02793 3.13761 9.07807 4.00525 9.19797C4.75627 9.30261 5.52361 9.29171 6.26997 9.16091C6.93236 9.04538 7 9.09552 7 9.36365C6.99534 11.282 6.99534 13.2025 6.99534 15.1208V15.1186Z"
                    stroke="currentColor"
                    strokeWidth="1.33"
                    strokeLinejoin="round"
                />
                <path
                    id="Vector_3"
                    d="M7 5.09302C7 6.65956 5.20406 7.81429 3.56954 6.58891C2.25185 4.96181 3.42627 3.10254 5.00227 3.10254C6.09598 3.10254 6.99798 4.0029 6.99798 5.09302H7Z"
                    stroke="currentColor"
                    strokeWidth="1.33"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
};

export default LinkedIn;
